import { render, staticRenderFns } from "./DisableEmails.vue?vue&type=template&id=62a825cb&scoped=true"
import script from "./DisableEmails.vue?vue&type=script&lang=js"
export * from "./DisableEmails.vue?vue&type=script&lang=js"
import style0 from "./DisableEmails.vue?vue&type=style&index=0&id=62a825cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a825cb",
  null
  
)

export default component.exports